module.exports = __webpack_public_path__ + "img/frame_2.da3aa9a9.png";